/** Reserves a heading and its first content together before either is drawn. */
export function keepPdfBlockTogether(top: number, bottom: number, heights: readonly number[], nextPage: () => void): void {
  let required = 0;
  for (const height of heights) required += height;
  if (top + required > bottom) nextPage();
}
